import React, { CSSProperties } from 'react';
import useAppAccessor from '../hooks/useappAccessor';
const NoResult = () => {
  const { getUserData } = useAppAccessor();
  const { language, client } = getUserData();
  const containerStyle : CSSProperties = {
    width: '375px',
    height: '103px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  const topTitleStyle : CSSProperties = {
    color: 'white',
    width: '375px',
    height: '36px',
    fontFamily: 'Poppins',
    fontSize: '26px',
    fontWeight: 500,
    lineHeight: '39px',
    letterSpacing: '0px',
    textAlign: 'center',
  };

  const bottomTitleStyle: CSSProperties = {
    color: 'white',
    width: '375px',
    height: '67px',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '27px',
    letterSpacing: '0px',
    textAlign: 'center',
  };
  return (
    <div style={containerStyle}>
      <div style={topTitleStyle}>
       {language['no_results']}
      </div>
      <div style={bottomTitleStyle}>
        {language['cannt_find']}
      </div>
    </div>
  );
};

export default NoResult;
